import { multiLineToGeo } from '@amcharts/amcharts4/maps';
import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'app/_services/dashboard.service';
import { PostService } from 'app/_services/post.service';
import { ProjectsService } from 'app/_services/projects.service';
import { ReportService } from 'app/_services/report.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
const moment = require('moment');
@Component({
  selector: 'app-dashboard7',
  templateUrl: './dashboard7.component.html',
  styleUrls: ['./dashboard7.component.scss']
})

export class Dashboard7Component implements OnInit {
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  listPosts = [];
  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };
  sourceByTopic = "";
  currentTag = null;
  modalRef: BsModalRef;

  brandDropDownSettings = {
    singleSelection: true,
    text: 'Chọn thương hiệu',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };
  projectDropDownSettings = {
    singleSelection: true,
    enableSearchFilter: true,
    text: 'Chọn chủ đề',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    badgeShowLimit: 2,
  };
  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;

  brandSelected = [];
  brands = [];

  projectSelected = [];
  projects = [];

  data_facebook = true;
  showSuggestPost = false;
  docTypeSelected = [{ 'id': 1, 'itemName': 'FACEBOOK', value: 'page_post user_post group_post' }];
  allDocTypes = [
    { 'id': 1, 'itemName': 'FACEBOOK', value: 'page_post user_post group_post' },
    // {'id': 2, 'itemName': 'NEWS', value: 'news_article news_blog news_forum'},
    // {'id': 3, 'itemName': 'YOUTUBE', value: 'youtube"'},
    // {'id': 4, 'itemName': 'TIKTOK', value: 'tiktok'},

    // {'id': 5, 'itemName': 'INSTAGRAM', value: '"instagram"'},
    // {'id': 6, 'itemName': 'LINKEDIN', value: '"linkedin"'},
    // {'id': 7, 'itemName': 'TWITTER', value: '"twitter"'}
  ]
  configAngularMultiSelect = {
    singleSelection: false,
    text: 'Vui lòng chọn',
    selectAllText: 'Chọn tất cả',
    unSelectAllText: 'Bỏ chọn tất cả',
    enableSearchFilter: true,
    badgeShowLimit: 2,
  };
  tags = [];

  projectsDisscussion = [];
  projectsDisscussionSelected = [];

  user_post = null;
  page_post = null;
  group_post = null;

  public likeShareTimeChartOptions = {
    // scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          stacked: true,
          display: false,
          labelString: 'Thời gian'
        }
      }],
      yAxes: [{
        id: 'A',
        scaleLabel: {
          display: true,
          labelString: 'Số lượng thảo luận',
        }
      }]
    },
    legend: {
      display: true,
      labels: {
        usePointStyle: true,
        fontSize: 11,
      }
    },
  };

  public lineChartLabels = [];

  public lineChart1Data = [
    { data: [65, 59, 80, 81, 56, 55, 40], label: 'Cá Nhân' },
    { data: [40, 69, 70, 21, 36, 55, 40], label: 'Trang' },
    { data: [40, 20, 40, 21, 36, 55, 40], label: 'Nhóm' }
  ];

  public likeShareTimeChartColours: Array<any> = [
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#4EBD74',
      borderWidth: 2,
      pointBackgroundColor: '#4EBD74',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
      // pointHoverBackgroundColor: '#fff',
      // pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#E749D7',
      borderWidth: 2,
      pointBackgroundColor: '#E749D7',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    },
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#0073FA',
      borderWidth: 2,
      pointBackgroundColor: '#0073FA',
      pointBorderColor: '#fff',
      pointBorderWidth: 1
    }

  ];
  public lineChartLegend = true;
  public lineChartType = 'line';



  public doughnutChartOptions: any = {
    cutoutPercentage: 0,
    rotation: 0,
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 1,
        arc: true,
        fontSize: 12,
        textMargin: 4,
        fontStyle: 'bold'
      }
    },
    legend: {
      display: false
    },
  }
  public doughnutChartType = 'doughnut';

  public doughnutChartLabels = ['Tổng tương tác', 'Còn lại'];

  public doughnutChartColors1 = [
    { backgroundColor: ["#4EBD74", "#bfbfbf"] }
  ];
  public doughnutChartColors2 = [
    { backgroundColor: ["#E749D7", "#bfbfbf"] }
  ];
  public doughnutChartColors3 = [
    { backgroundColor: ["#0073FA", "#bfbfbf"] }
  ];

  public doughnutChartData1 = [
    [30, 70]
  ];
  public doughnutChartData2 = [
    [30, 70]
  ];
  public doughnutChartData3 = [
    [30, 70]
  ];

  constructor(
    private projectsService: ProjectsService,
    private dashboardService: DashboardService,
    private toastrService: ToastrService,
    private modalService: BsModalService,
    private reportService: ReportService
  ) {

  }

  ngOnInit() {
    this.getBrands();
    this.getProject();
  }
  pageChange(number) {
    this.listPosts = [];
    this.currentPageRecommand = number;
    this.viewPost();
  }
  showRecommentPost(modalRef, tagName) {
    this.currentTag = tagName;
    this.currentPageRecommand = 1;
    this.viewPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }
  viewPost() {
    this.listPosts = [];
    const filterFacebook = {
      filter: {
        gte: this.daterangeFilter.start.valueOf(),
        lte: this.daterangeFilter.end.valueOf(),
        currentTag : this.currentTag,
        projectsDisscussionSelected: this.projectsDisscussionSelected,
      },
      projects : this.projectSelected,
      brands: this.brandSelected,
      size: this.pageSizeRecommand,
      from: (this.currentPageRecommand - 1) * this.pageSizeRecommand,
      type: 'facebook'
    };
    this.dashboardService.getSuggestionPost(filterFacebook).subscribe(res => {
      if (res.success) {
        this.listPosts = this.mappingData(res.data.hits.hits);
        this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand)
      }
    });
  }
  mappingData(hits) {
    let results = [];
    hits.forEach(item => {
      let reportItem = {
        source: item["_source"].sourceName + "  " + moment(item["_source"].createDate).format('DD/MM/YYYY h:mm:ss a'),
        message : item["_source"].message,
        linkSource : this.getSourceLink(item),
        numLikes: item["_source"].numLikes + item["_source"].numReactions,
        numShares: item["_source"].numShares,
        numComments: item["_source"].numComments,
        total_interactive : (item["_source"].numShares || 0 ) + (item["_source"].numComments || 0 ) + (item["_source"].numLikes + item["_source"].numReactions || 0 )
      }

      results.push(reportItem);
    });
    return results;
  }

  getSourceLink(item) {
    let linkSource = item._source.link;;

    if(item._source.docType == 'page_post' || item._source.docType == 'user_post' || item._source.docType == 'group_post' || item._source.docType == 'comment') {
      return `https://facebook.com/${item._id}`;
    }
    if (item['_source'].docType == 'tiktok_comment') {
      linkSource = `https://www.tiktok.com/@${item['_source'].name}/video/${item['_source'].postId}`;
    }
    if (item['_source'].docType == 'youtube_comment') {
      linkSource = `https://www.youtube.com/watch?v=${item['_source'].postId}`;
    }

    return linkSource;
  }
  getBrands() {
    this.projectsService.getBrandsActiveV2().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
            fanpageId: element.fanpageId ? element.fanpageId : null
          };
          this.brands.push(obj);
        });
      }
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        for (let index = 0; index < response.data.projects.length; index++) {
          const element = response.data.projects[index];
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(obj);
        }
      }
    });
  }
  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  getProjectDiscussion(event:any) {
    const {id} = event;
    const projects = [];
    if(!id) return;
    projects.push(event)
    this.projectsDisscussion = [];
    this.projectsDisscussionSelected = [];

    this.projectsService.getProjectDiscussionByProject({ projects}).subscribe(res => {
      if (res.success) {
        res.data.projectsDiscussion
          .forEach(element => {
            let obj = {
              id: element._id,
              itemName: element.name,
              value: element.name
            };
            this.projectsDisscussion.push(obj);
          });
      }
    })
  }

  getDataFromServer() {
    if ((this.brandSelected.length || this.projectSelected.length) && this.docTypeSelected.length) {
      this.data_facebook = this.docTypeSelected.find(x => x.id == 1) ? true : false;

      const filter = {
        projects: this.projectSelected,
        brands: this.brandSelected,
        projectsDisscussionSelected: this.projectsDisscussionSelected,
        gte: this.daterangeFilter.start.valueOf(),
        lte: this.daterangeFilter.end.valueOf(),
        docTypeSelected: this.docTypeSelected,
        sourceByTopic: this.sourceByTopic,
      };
      this.lineChartLabels = [];
      this.lineChart1Data = [];
      this.dashboardService.getTopHashtag({ filter: filter }).subscribe(res => {
        console.log(res);
        if (res.success) {
          this.lineChart1Data = [
            { data: [], label: 'Cá nhân' },
            { data: [], label: 'Trang' },
            { data: [], label: 'Nhóm' }
          ];

          res.data.aggregations.byday.buckets.forEach(element => {
            this.lineChartLabels.push(element.key_as_string);
            this.lineChart1Data[0].data.push(element.user_post.doc_count);
            this.lineChart1Data[1].data.push(element.page_post.doc_count);
            this.lineChart1Data[2].data.push(element.group_post.doc_count);
          });


          this.user_post = null;
          this.page_post = null;
          this.group_post = null;

          this.user_post = res.data.aggregations.user_post;
          this.page_post = res.data.aggregations.page_post;
          this.group_post = res.data.aggregations.group_post;

          const total_post = this.user_post.interactive.value + this.page_post.interactive.value + this.group_post.interactive.value;

          this.doughnutChartData1 = [];
          this.doughnutChartData2 = [];
          this.doughnutChartData3 = [];

          this.doughnutChartData1 = [this.user_post.interactive.value, (total_post - this.user_post.interactive.value)];
          this.doughnutChartData2 = [this.page_post.interactive.value, (total_post - this.page_post.interactive.value)];
          this.doughnutChartData3 = [this.group_post.interactive.value, (total_post - this.group_post.interactive.value)];

          this.tags = [];
          let total = 0;

          res.data.aggregations.tags.buckets.forEach(tag => {
            const interactive = tag.interactive ? (tag.interactive.value ? tag.interactive.value : 0) : 0
            total = total + interactive;
          });

          res.data.aggregations.tags.buckets.forEach(tag => {
            const interactive = tag.interactive ? (tag.interactive.value ? tag.interactive.value : 0) : 0
            this.tags.push({
              key: tag.key ? tag.key : 'không xác định',
              doc_count: interactive,
              percent: Math.round((interactive / total) * 100)
            });
            this.tags.sort((a,b) => b.doc_count - a.doc_count)
          });
        } else {
          this.toastrService.error(res.msg, "Thông báo");
        }
      });
    } else if (!this.docTypeSelected.length) {
      this.toastrService.warning("Vui lòng chọn loại nội dung", "Thông báo");
    } else {
      this.toastrService.warning("Vui lòng chọn chủ đề hoặc thương hiệu", "Thông báo")
    }

  }

  exportExcel() {

    const filterFacebook = {
      filter: {
        gte: this.daterangeFilter.start.valueOf(),
        lte: this.daterangeFilter.end.valueOf(),
        currentTag : this.currentTag
      },
      projects : this.projectSelected,
      brands: this.brandSelected,
      size: 10000,
      from: 0,
      type: 'facebook'
    };
    this.dashboardService.getSuggestionPost(filterFacebook).subscribe(res => {
      if (res.success) {
        const posts = this.mappingData(res.data.hits.hits);
        if(posts.length) {
          let dataReport = [];

          let header  = [
            { start: 1 },
            { name: 'STT' },
            { name: 'Nguồn' },
            { name: 'Nội dung' },
            { name: 'Link bài đăng' },
            { name: 'Lượt thích' },
            { name: 'Bình luận' },
            { name: 'Chia sẻ' },
            { name: 'Tổng tương tác' }
          ];
          dataReport.push({ name: `Báo cáo danh sách bài viết theo hashtag ${this.currentTag}`, header: [header], data: posts });
          this.reportService.exportReportToExcel(dataReport, `Báo cáo danh sách bài viết theo hashtag ${this.currentTag}`);
        }else {
          this.toastrService.warning('Dữ liệu không tồn tại để xuất báo cáo', 'Thông báo')
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard7/dashboard7.component.ts